import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { BounceLoader, useSelectedDealer } from "components";
import { CAR_TYPE, LANDING_PAGES, LANGUAGE_CODES, ROLES, USER_STATUSES } from "models";
import { Agreements, DataProtectionOfficer, PrivacyOverview } from "modules/PrivacyAndSecurityDashboard/components";
import { usePrivacyAndSecurityStatusQuery } from "modules/PrivacyAndSecurityDashboard/hooks";
import "modules/PrivacyAndSecurityDashboard/PrivacyAndSecurityDashboard.scss";

import type { User } from "models";

const claireDataProtectionOfficer: User = {
  created_on: "",
  updated_on: "",
  id: -1,
  dms_nr: null,
  dms_location_source: "",
  external_user_id: "",
  first_name: "dhr A.J.P",
  last_name: "van den Eijnden",
  email: "dpo@claireit.nl",
  username: "",
  mobile: "",
  phone: "",
  address1: "",
  address2: "",
  status: USER_STATUSES.UserActive,
  web_version: "",
  app_version: "",
  camera_version: "",
  location_column_visible: false,
  multi_device_login_enabled: false,
  is_combi_user: false,
  has_leased_tablet: false,
  list_appointments_by_scheduled_range: false,
  csv_download: false,
  profile_picture: "",
  language_code: LANGUAGE_CODES.Dutch,
  dealer_id: -1,
  dealer_location_id: -1,
  role_id: ROLES.SuperAdmin,
  landing_page_id: LANDING_PAGES.Main,
  is_counter_tablet_user: false,
  is_keylocker_allowed: false,
  is_tablet_translation_ai_enabled: false,
  is_available: false,
  pin_status_notification_enabled: false,
  tyre_ordering_enabled: false,
  shop_status_same_day_filter_enabled: false,
  shop_status_next_day_filter_enabled: false,
  shop_status_to_order_filter_enabled: false,
  shop_status_backorder_filter_enabled: false,
  shop_status_arrived_parts_filter_enabled: false,
  working_on: null,
  day_planner_appointments_collapsed_by_default: false,
  day_planner_cars_ready_collapsed_by_default: false,
  day_planner_quality_control_collapsed_by_default: false,
  dpo: true,
  customer_waiting_car_in_shop_notification_enabled: false,
  car_type_filter: CAR_TYPE.Unknown,
  star_color_green_enabled: false,
  star_color_red_enabled: false,
  star_color_blue_enabled: false,
  star_color_yellow_enabled: false,
  is_vat_enabled_on_wo: false,
  is_desktop_notifications_enabled: false
};

export const PrivacyAndSecurityDashboard = () => {
  const { t } = useTranslation();

  const { selectedDealer } = useSelectedDealer();
  const { data: privacyAndSecurityStatus, isFetching } = usePrivacyAndSecurityStatusQuery(selectedDealer?.id);

  if (isFetching)
    return (
      <div className="PrivacyAndSecurityDashboardLoader">
        <BounceLoader show={isFetching} />;
      </div>
    );

  if (!privacyAndSecurityStatus) return null;

  return (
    <Grid className="PrivacyAndSecurityDashboard">
      <Grid.Column width={10}>
        <div className="privacy-gdoc-container">
          <iframe className="privacy-gdoc" title="privacyGDoc" src="https://storage.googleapis.com/claire-dpo-resources/GDPR-AVG-Claire.pdf"></iframe>
        </div>
      </Grid.Column>

      <Grid.Column width={6}>
        <DataProtectionOfficer title={t("v8_data_protection_officer", "Data protection officer")} dataProtectionOfficer={privacyAndSecurityStatus.data_officer} />
        <Agreements agreementsHistory={privacyAndSecurityStatus.history} />
        <DataProtectionOfficer
          title={t("v8_claire_data_protection_officer_title", "Claire Automotive Support B.V. Data Protection Officer")}
          dataProtectionOfficer={claireDataProtectionOfficer}
          isClaireDPO
        />
        <PrivacyOverview />
      </Grid.Column>
    </Grid>
  );
};
